module.exports = __webpack_public_path__ + "img/horizontal_6_6_6005.7a1ffb23.png";